import cookieAndLocalStorage from "../../helpers/cookieAndLocalStorage";

const FETCH_REQUESTS = 'request/FETCH_REQUESTS';
const FETCH_REQUESTS_SUCCESS = 'request/FETCH_REQUESTS_SUCCESS';
const FETCH_REQUESTS_FAIL = 'request/FETCH_REQUESTS_FAIL';
const SELECT_REQUEST = 'request/SELECT_REQUEST';

const UPDATE_REQUEST = 'request/UPDATE_REQUEST';
const UPDATE_REQUEST_SUCCESS = 'request/UPDATE_REQUEST_SUCCESS';
const UPDATE_REQUEST_FAIL = 'request/UPDATE_REQUEST_FAIL';

const DELETE_REQUEST = 'request/DELETE_REQUEST';
const DELETE_REQUEST_SUCCESS = 'request/DELETE_REQUEST_SUCCESS';
const DELETE_REQUEST_FAIL = 'request/DELETE_REQUEST_FAIL';

const GET_REQUEST = 'request/GET_REQUEST';
const GET_REQUEST_SUCCESS = 'request/GET_REQUEST';
const GET_REQUEST_FAIL = 'request/GET_REQUEST_FAIL';

const initialState = {
  pageCount: 1,
  requests: [],
  loading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_REQUESTS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        requests: (action.result.data ? action.result.data.data : []),
        pageCount: (action.result.data ? action.result.data.pageCount : 1),
        lastBusinessDayOfMonth: (action.result.data ? action.result.data.lastBusinessDayOfMonth : []),
      };
    case FETCH_REQUESTS_FAIL:
      cookieAndLocalStorage();
      return {
        ...state,
        loading: false,
        error: action.error.data,
      };
    case SELECT_REQUEST:
      const tempRequests = state.requests.map((request) => {
        if (request.id === action.id) request.selected = !request.selected;

        return request;
      });

      return {
        ...state,
        requests: tempRequests,
      };
    case GET_REQUEST:
      return {
        ...state,
      };
    case GET_REQUEST_SUCCESS:
      return {
        ...state,
      };
    case GET_REQUEST_FAIL:

      return {
        ...state,
        error: action.error.data
      };
    case UPDATE_REQUEST:
      return {
        ...state,
      };
    case UPDATE_REQUEST_SUCCESS:
      return {
        ...state,
        requests: state.requests.map((requestArr) => {
          const newData = requestArr.harcirah.map((harcirah) => {
            if (harcirah._id === action.payload._id) {
              return action.payload;
            }

            return harcirah;
          });

          return { ...requestArr, harcirah: newData };
        }),
      };
    case UPDATE_REQUEST_FAIL:
      return {
        ...state,
        error: action.error.data
      };
    case DELETE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        requests: state.requests.filter((group) => {
          group.harcirah = group.harcirah.filter(
            harcirah => harcirah._id !== action.payload.harcirahId);

          return group.harcirah.length > 0;
        }),
      };
    case DELETE_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error.data
      };
    default:
      return state;
  }
}

export function fetchRequests(params) {
  return {
    types: [FETCH_REQUESTS, FETCH_REQUESTS_SUCCESS, FETCH_REQUESTS_FAIL],
    promise: client => client.post('/harcirah/lists', { data: {}, params }),
  };
}
export function getRequest(harcirahId) {
  return {
    types: [GET_REQUEST, GET_REQUEST_SUCCESS, GET_REQUEST_FAIL],
    loading: true,
    promise: client => client.post('/harcirah/get', {
      data: {
        harcirahId,
      },
    }),
  };
}
export function updateRequest(payload) {
  return {
    types: [UPDATE_REQUEST, UPDATE_REQUEST_SUCCESS, UPDATE_REQUEST_FAIL],
    payload,
    loading: true,
    promise: client => client.post('/harcirah/update', { data: payload }),
  };
}
export function deleteRequest(groupId, harcirahId) {
  const payload = {
    groupId,
    harcirahId,
  };

  return {
    types: [DELETE_REQUEST, DELETE_REQUEST_SUCCESS, DELETE_REQUEST_FAIL],
    payload,
    promise: client => client.post('/harcirah/delete', {
      data: payload,
    }),
  };
}
export function selectRequest(id) {
  return { type: SELECT_REQUEST, id };
}



// WEBPACK FOOTER //
// ./src/redux/modules/request.js